import Vue from 'vue';
import Vuex from 'vuex';

import storeBaseConfig from '@app/common/store/store.base.config';

// eslint-disable-next-line import/no-cycle
import RiskSpace from './riskspace';
import AutoDamage from './autodamage';
import Auth from './auth';
import GeoLocation from './geolocation';

Vue.use(Vuex);

const store = new Vuex.Store({
    ...storeBaseConfig,
    state: {
        loading: false,
        loaded: false,
        records: {},
    },
    modules: {
        riskspace: RiskSpace,
        autodamage: AutoDamage,
        auth: Auth,
        geolocation: GeoLocation,
    },
});

export default store;
